import React from 'react';
import clsx from 'clsx';

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  children?: React.ReactNode;
  className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, description, children, className }) => (
  <div className={clsx('py-24 text-center space-y-4', className)}>
    {icon && (
      <div className="w-16 h-16 mx-auto bg-slate-100 dark:bg-slate-800 rounded-2xl flex items-center justify-center">
        {icon}
      </div>
    )}
    <div>
      <p className="font-bold text-slate-700 dark:text-slate-300">{title}</p>
      {description && <p className="text-sm text-slate-500 dark:text-slate-400 mt-1">{description}</p>}
    </div>
    {children}
  </div>
);
